const ckconfig = {
  toolbar: [ 'heading', '|', 'bold', 'italic','underline', 'striketrough', 'link','alignment', 'bulletedList', 'numberedList', 'blockQuote', 'undo', 'redo'   ],
  alignment: {
    options: [ 'left', 'right', 'center' ]
  },
}
export default ckconfig;
